<template>
  <!-- 运维上传也先走统一素材库：选用已有不增行；库内「+上传」才写 infra_file -->
  <TenantMaterialSelector
    v-model="materialVisible"
    default-module="infra"
    :file-size-mb="20"
    :multiple="true"
    media-type=""
    @confirm="onMaterialConfirm"
  />
</template>
<script lang="ts" setup>
import TenantMaterialSelector from '@/components/TenantMaterialSelector/index.vue'
import type { FileVO } from '@/api/infra/file'

defineOptions({ name: 'InfraFileForm' })

const message = useMessage()

const materialVisible = ref(false)
const emit = defineEmits(['success'])

/** 打开弹窗 = 打开素材库 */
const open = async () => {
  materialVisible.value = true
}
defineExpose({ open })

const onMaterialConfirm = (_items: FileVO[]) => {
  // 选用已有 / 库内新传后：刷新文件列表即可
  message.success('已完成')
  emit('success')
}
</script>
